import styled from 'styled-components';
import { Card, Container } from 'react-bootstrap';
import { media } from 'utils/rwd';

export const StyledContainer = styled(Container)`
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
`;

export const StyledCard = styled(Card)`
  display: flex;
  justify-content: center;
  padding: 1rem 2rem;
  margin: 0.375rem;

  ${media.xs`
    padding: 1.5rem 3rem;
  `}

  ${media.lg`
    padding: 2.25rem 4.5rem;
  `}
`;
